import { createSlice } from '@reduxjs/toolkit';

const socketSlice = createSlice({
  name: 'socket',
  initialState: {
    connected: false,
    connecting: false,
    socketId: null,
    error: null
  },
  reducers: {
    connected: (state, action) => {
      state.connected = true;
      state.connecting = false;
      state.socketId = action.payload;
      state.error = null;
    },
    disconnected: (state) => {
      state.connected = false;
      state.connecting = false;
      state.socketId = null;
    },
    error: (state, action) => {
      state.error = action.payload;
      state.connecting = false;
    },
    connecting: (state) => {
      state.connecting = true;
    }
  }
});

export const socketActions = socketSlice.actions;
export default socketSlice.reducer;